import React, {useEffect, useState} from 'react';
import { useSelector , useDispatch} from 'react-redux';
import {
  Grid, Button, Stack, Box, Chip, Link,
  Paper, Typography,IconButton, Tooltip, Collapse, Fab,
  InputLabel,Select, FormControl, FormHelperText, FormGroup, FormControlLabel, ListItem,
  MenuItem
} from '@mui/material';

import {useViewContext} from '../utils/ViewContext';

import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Autocomplete from '@mui/material/Autocomplete';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';

import { DesktopTimePicker, DesktopDatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';


import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CreateIcon from '@mui/icons-material/Add';
import ResetIcon from '@mui/icons-material/HighlightOff';
import AddIcon from '@mui/icons-material/Add';

import RefreshIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';



import {usePlayContext} from '../utils/PlayContext';

import {  selectAllApplications, 
  refreshApplications,
          selectApplicationById,
          selectApplicationByFilter,
          selectAllSubjects} from '../store/applicationSlice' 

import { useNavigate, useLocation } from 'react-router-dom';
          
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import GroupIcon from '@mui/icons-material/Group';

import { AllInclusiveRounded } from '@mui/icons-material';

import {  
  selectAllFloors,
  //selectSiteById,
  //selectSiteIds,
}  from '../store/floorSlice'
import { selectAllReasons } from '../store/reasonSlice';
import { getDateDisplayIdString } from '../utils/timeConfig';




const InvitationItem = ({id})=>
{

    const it = useSelector(selectApplicationById(id))
    const navigate = useNavigate()

    let icon = it.type==='GROUP' ? <GroupIcon fontSize='inherit' /> :<PersonIcon fontSize='inherit' />
    
    
    const rightNow = Date.now();


    let  iconColor= 'primary.light'
    let myColor="text.primary"

    if ('EXPIRED'===it.status || (Boolean(it.formattedEndTm) && it.formattedEndTm<rightNow) )
    {
        myColor='text.secondary'
        iconColor='light'
    }
    else  if ('CANCELLED'===it.status) 
    {
      myColor='warning.main'
      iconColor='warning.light'
    }

    return(
      <Card 
                sx={{width:'100%', border:1,  color: `${myColor}`  , borderColor:`${iconColor}`}}>
          <CardHeader
            onClick={()=>navigate('/invitations/view/'+it.id)}

            avatar={
              <Avatar sx={{ bgcolor: `${iconColor}` }}>
                {icon}
              </Avatar>
            }

            action={
              
              <Typography variant='subtitle2'>
                #{getDateDisplayIdString(new Date(it.timestamp))}-{it.id}
                  {/** 
                  <IconButton aria-label="settings" >
                    <ArrowCircleRightIcon    sx={{color:`${iconColor}` }} size='large'/>
                  </IconButton>
                  */}
              </Typography> 
            }
            title={<Link><Typography variant='h6'>{it.reason}</Typography></Link>}
  
            subheader={  
              <Typography variant='body2'><small>{
                it.reoccurenceId && it.reoccurenceMessage ?
                      it.reoccurenceMessage:'one-time invitation'}</small></Typography> 
            }
            
                        />
      
      
      <CardContent sx={{py:0, my:0}}>

<Grid container   spacing={2}>
  <Grid  container item xs={12} md={11} lg={11} 
      sx={{
        px:1,
        border:0, borderColor:'#dddddd'}}>

  <Grid item xs={12} md={6} lg={4}>
    <Typography variant='body2'
      ><strong>Start Date Time :&nbsp;</strong>{it.startTm}
    </Typography>
  </Grid>
  <Grid item xs={12} md={6} lg={4}>
    <Typography variant='body2'
      ><strong>End Date Time :&nbsp;</strong>{it.endTm ? it.endTm:'N/A'}
    </Typography>
  </Grid>
  
  

  <Grid item xs={12} md={6} lg={4}>
    <Typography variant='body2'
      ><strong>Floor :&nbsp;</strong>{it.floor}
    </Typography>
  </Grid>
  
  
  <Grid item xs={12} md={6} lg={4}>
    <Typography variant='body2'
      ><strong>Type :&nbsp;</strong>{it.type}
    </Typography>
  </Grid>
  {
      ('GROUP'===it.type) &&
      <>
        <Grid item xs={12} md={6} lg={4}>
          <Typography variant='body2'
            ><strong>Max Person No. :&nbsp;</strong>{it.groupMaxPerson}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Typography variant='body2'
            ><strong>Group Email :&nbsp;</strong>{it.groupSendToEmail}
          </Typography>
        </Grid>
      </>

  }
  
  <Grid item xs={12} md={6} lg={4}>
    <Typography variant='body2'
      ><strong>Status :&nbsp;</strong>{it.status}
    </Typography>
  </Grid>
  <Grid item xs={12} md={6} lg={4}>
    <Typography variant='body2'
      ><strong>Remarks:&nbsp;</strong>{it.remarks}
    </Typography>
  </Grid>
  <Grid item xs={12} >
  <Box sx={{width:'100%', pt:1, display: 'flex' }}><Typography variant='body2' 
      ><strong>Visitors:</strong>
    </Typography>

      <Stack direction="row" spacing={1}
      sx={{border:0, px:1, borderRadius:2, borderColor:'#dddddd', flexWrap:'wrap'}}>
              {
                 it.invitationVisitors && it.invitationVisitors.map((x,index1)=>
                    <Chip label={x.name ? x.name:x.email}  key={x.id}  
                        icon={x.name ?<PersonIcon />:<EmailIcon/>}
                        color="default"  
                        size='small'
                        sx={{}}
                    />
                    )
              
              }
        </Stack>

</Box>
  </Grid>
</Grid>
<Grid item xs={12} md={1}  lg={1} 
    sx={{backgroundColor:'none', 
    display:{xs:'block', md:'block'}}}
    style={{padding:0, margin:0}}
    >
    <Stack spacing={3} direction={{xs:'row', md:'column'}} 
        alignItems="center" 
        justifyContent={{md:"center", xs:'space-around'}}
        sx={{
            backgroundColor:'none', 
            width:'100%', p:1,
            mt:{sm:1, xs:1}
            
          }}

      >
      <Button size='small' variant='outlined'  sx={{display:'block',width:115}}
	  color='success'
          onClick={()=>navigate('/invitations/view/'+it.id)}
        >Edit</Button>
      
{(it.status!=='EXPIRED'&&it.status!=='CANCELLED' &&it.status!=='ENROLED' &&
                    it.formattedEndTm > Date.now())?
                   ( <Button size='small' variant='outlined'   color='success'
                   sx={{display:'block',width:115}} 
                   onClick={e=>{navigate('/invitations/cancel/'+it.id)}}
                 >Cancel Invitation</Button>)
                 :
                 (<Button size='small' variant='outlined'   color='success'
                 sx={{display:'block',width:115}} 
                 onClick={e=>{navigate('/invitations/delete/'+it.id)}}
               >Permanently delete
             </Button>)
                    }

    </Stack>
</Grid>
</Grid>


</CardContent>  
       {/** 
       <CardActions>
            <Box sx={{ display:'flex' , width:'100%', px:2}}>
                  <Button
                    onClick={()=>{navigate('/invitations/view/'+it.id)}}
                  >View</Button>
            </Box>
       </CardActions>
       */}
      </Card>
  );

}



const InvitationFilterPane=()=>{

  const {
    setOp,
    status, setStatus, appTitle, setAppTitle, 
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
    setTenantLogo
  }=usePlayContext()


  const {
    viewFilter, setViewFilter
  }=useViewContext()

      //const allSubjects = useSelector(selectAllSubjects)
      const visit_reasons = useSelector(selectAllReasons)
      const dispatch = useDispatch();
      const navigate = useNavigate()
      
      const floors = useSelector(selectAllFloors)

      const [start, setStart] = React.useState(viewFilter?.start?viewFilter?.start:null)
      const [end, setEnd] = React.useState(viewFilter?.end?viewFilter?.end:null)
        const [floor, setFloor] = React.useState(viewFilter?.floor ? viewFilter?.floor:''  );
        const [subject, setSubject] = React.useState(viewFilter?.subject ? viewFilter?.subject:'');
        const [expanded, setExpanded] = React.useState(true);
        const [endDateTimeError, setEndDateTimeError] = useState(''); 
        const handleExpandClick = () => {
          setExpanded(!expanded);
        };

        const handleReset = ()=>{
            setStart(null)
            setEnd(null)
            setFloor('')
            setSubject('')
            setEndDateTimeError('')

            setViewFilter({
              start:null,
              end:null,
              floor:'',
              subject:'',

          })
        }

        const doToday= ()=>
        {
            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            } 
            //alert("name2="+__dd(name))
            setFloor('')
            setSubject('')

            let DDD = new Date();


            let start= new Date(DDD.getFullYear(), DDD.getMonth(), DDD.getDate())
            let end = new Date(DDD.getFullYear(), DDD.getMonth(), DDD.getDate(), 23, 59, 59,999)
            
            setStart(start)
            setEnd(end)

            let newVal = 
            {
              start: start,
              end: end, 
              floor : null, 
              subject: null,
            }
            setViewFilter(newVal)

        }
        const doThisWeek= ()=>
        {
            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            }
           
            const today = new Date();
            const firstday = new Date(today.setDate(today.getDate() - today.getDay()));
            const lastday = new Date(today.setDate(today.getDate() - today.getDay() + 6));

            setFloor('')
            setSubject('')
            setStart(firstday)
            setEnd(lastday)

            let newVal = 
            {
              start: firstday,
              end: lastday, 
              floor:null, 
              subject:   null, //__dd(subject),
            }
            setViewFilter(newVal)

        }
        const doThisMonth= ()=>
        {
            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            }
           

            const now = new Date();
            const firstday = new Date(now.getFullYear(), now.getMonth(), 1);
            //console.log(firstday); // 👉️ Sat Oct 01 2022 ...

            const lastday = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            //console.log(lastday); // 👉️ Mon Oct 31 2022 ...
            setFloor('')
            setSubject('')
            setStart(firstday)
            setEnd(lastday)

            let newVal = 
            {
              start: firstday,
              end: lastday, 
              floor:null, 
              subject:   null, //__dd(subject),
            }
            setViewFilter(newVal)

        }

        const doFilterApplication= ()=>
        {
            let errNo=0;
            //alert("name="+name)

            //alert(start)
            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            }
            //alert("name2="+__dd(name))

            let start1 = Boolean(start) && !isNaN(start) ? 
                new Date(start.getFullYear(), start.getMonth(), start.getDate()):
                null
            let end1 = Boolean(end) && !isNaN(end) ? 
              new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59,999):
              null
            if (!isNaN(end1) && !isNaN(start1) && end1<start1 )
            {
                errNo++;
                setEndDateTimeError('End Time cannot be earlier than Start Time')    
                  
            }  

            if (errNo>0) return
              
            let newVal = 
            {
              start: start1,
              end: end1, 
              floor, 
              subject: __dd(subject),
            }
            setViewFilter(newVal)

        }
        
        const doRefresh = async ()=>{
        
          handleReset()
        
          setStatus('processing')
        
        
          try
          {
            let resp = await dispatch(          refreshApplications()).unwrap();

              setStatus('idle')
          }
          catch (ex)
          {
            setStatus('error')
            setErrorMessage("Cannot retrieve Visitor info")
          } 
        }

  return (
    <Card  
          sx={{m:1, p:0, border:1}}>
          <CardActions  disableSpacing   sx={{pl:2,my:0, }}> 
            <Tooltip title="Create Invitation">
              <Fab variant="extended" size="small" color="primary" aria-label="add"
                    onClick={(e)=>navigate('/invitations/invite')} 
                  >
                  <AddIcon sx={{ mr: 1 }} />
                  Add Invitation
              </Fab>            
            </Tooltip>
            {/** 
            <Button variant="outlined"
                  sx={{textTransform:'none'}}
                  onClick={(e)=>navigate('/invitations/invite')} 
                >
              <CreateIcon />Invite Visitor(s)
            </Button>
            */}

              <Typography sx={{marginLeft:'auto', color:'primary.main'}} 
                    onClick={handleExpandClick }>Search</Typography>
              <IconButton size='large' color='primary' 
                onClick={handleExpandClick }
              >
                {  expanded ? <ExpandLessIcon />:<ExpandMoreIcon />}
              </IconButton>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>

            <CardContent>
              <Grid  container 
                          spacing={1}
                          columns={24}
                          sx={{py:0, 
                          mb:{xs:0, md:0},
                          px:{xs:1, md:0},
                          border:{xs:0,md:0},
                          borderColor:'#aaaaaa',
                          borderRadius:1,
                          }}>
                <Grid item xs={24} sm={12}  md={6} lg={6}>
            
                  <Autocomplete 
                      fullWidth
                      size='small'
                      // freeSolo
                      selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_reason" 
                      value={subject}
                      options={visit_reasons.map((option) => option.reason)}  
                      onChange = { (e, newValue)=>{setSubject(newValue);   } }
                      renderInput={(params) => 
                          <TextField {...params} 
                            // onChange = { e=>{setSubject(e.target.value);}}
                            label="Purpose"  
                            //inputProps={{ maxLength: 100, minLength:5 }}
                            //helperText={ Boolean(reasonVisitError) ? reasonVisitError : "Subject for the visit"}
                            />}

                      />
        
                </Grid>
                <Grid item xs={24} sm={12}  md={6} lg={6}>
            
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker 
                      label="Start Date"
                      onChange={(newValue) => {  setStart(newValue);}}
                      value={start}

                      inputFormat="dd/MM/yyyy"

                      renderInput={(props) => 
                      <TextField {...props} 
                          
                          fullWidth 
                          size='small'
                          />}
                      
                      />
                  </LocalizationProvider>
             </Grid>
             <Grid item xs={24} sm={12}  md={6} lg={6}>
            
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker 
                      inputFormat="dd/MM/yyyy"
                      renderInput={(props) => 
                      <TextField {...props} 
                          
                          size='small'
                          fullWidth 
                          error={Boolean(endDateTimeError)}
                      helperText={Boolean(endDateTimeError)? endDateTimeError : '' }
                          />}
                      label="End Date"
                      value={end}
                      onChange={(newValue) => {  setEnd(newValue);}}
                      
                  />
                  </LocalizationProvider>
              </Grid>
              <Grid item xs={24} sm={12}  md={6} lg={6}>
            
                    <FormControl  fullWidth  size='small'>
                      <InputLabel id="id_floor_label" >Floor</InputLabel>
                        <Select
                            required
                            labelId="id_floor_label"
                            //error={Boolean(siteError)}
                            id="id_flooe"
                            value={floor}
                            label='Floor'
                            onChange={(e)=>setFloor(e.target.value)}
                            >
                          <MenuItem value={''}></MenuItem>
                            {
                                floors.map( (ct)=>
                                  (<MenuItem key={ct.id} value={ct.name}>{ct.name}</MenuItem>)
                                )
                            }
                      </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={24}  md={12} lg={12}  >
                    <Box sx={{ display:'flex', flexDirection:'row', justifyContent: 'space-around' , m:0,p:0, 
                        width:'100%'}}>
                        <Button variant="outlined"size='small' color='primary' 
                                onClick={doToday}
                                sx={{textTransform:'none'}}
                              >
                            Today
                        </Button>
                        <Button variant="outlined"size='small' color='info' 
                                  onClick={doThisWeek}
                                  sx={{textTransform:'none'}}
                                  >
                          This Week
                      </Button>
                      <Button variant="outlined"size='small' color='info' 
                                  onClick={doThisMonth}
                                  sx={{textTransform:'none'}}
                                  //disabled={![phone, email, name,company].some(Boolean)}
                                  >
                         This Month
                      </Button>
                      <Button variant="outlined"size='small' color='info' 
                                  onClick={handleReset}
                                  sx={{textTransform:'none'}}
                                  >
                          All Days
                      </Button>
                    </Box>
                 </Grid>
                 <Grid item xs={24}   md={12} lg={12} >
                    <Box sx={{ display:'flex', flexDirection:'row', justifyContent: 'space-around' , m:0,p:0, 
                        width:'100%'}}>
                        <Button variant="outlined"size='small' 
                                onClick={doFilterApplication}
                                //color='success'
                                sx={{textTransform:'none'}}

                              >
                            <SearchIcon sx={{display:{xs:'block', sm:'block'}}}/>
                            Search
                        </Button>
                         <Button variant="outlined"size='small' 
                                  color='primary'
                                onClick={handleReset}
                                sx={{textTransform:'none'}}

                              >
                            <ResetIcon sx={{display:{xs:'block', sm:'block'}}}/>
                            Clear
                        </Button>
                      {/* <Button variant="outlined"size='small'  
                                  onClick={doRefresh}
                                  color='success'
                                  sx={{textTransform:'none'}}
  
                                  
                                  >
                          <RefreshIcon />
                          Refresh
                      </Button> */}
                    </Box>
                 </Grid>
              </Grid>
            </CardContent>
          </Collapse>
      </Card>       

  )

}

//#######################################################

const InvitationListPage = () => {


    const {
      setAppTitle, 
      setErrorMessage, 
      setErrorTitle,
          }=usePlayContext()


    const {
      viewFilter, 
    }=useViewContext()
    
    const idss = useSelector(state=> selectApplicationByFilter(state, viewFilter))

  
    useEffect(() =>{
      setAppTitle( ['Invitations'])
      setErrorMessage('')
      setErrorTitle('')
      
    }, [])
  
    
  return (

    <Box sx={{ p:0, width:'100%' }}>
      <InvitationFilterPane/>  
      <Paper sx={{border:'none', justifyContent: "flex-start", px: 1}} elevation={4} >
        
      <Stack sx={{ width: '100%' , mt:1}} spacing={1}>
            {
              idss.map(  (id, index)=>{
                return (<InvitationItem key={id} id={id}/>)
            })
            }
          </Stack>

      </Paper>
      

      
    </Box>
  );
};

export default InvitationListPage;
